import React, { useMemo, useState } from 'react';
import { MapContainer, TileLayer, Marker } from 'react-leaflet';
import L from 'leaflet';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import CatchLightbox from './CatchLightbox';
import 'leaflet/dist/leaflet.css';

function createCatchIcon(c) {
  const hasImage = !!c.imageUrl;
  const bg = hasImage
    ? `background:#111 url('${c.imageUrl}') center/cover no-repeat`
    : `background:#36c9a2`;
  const inner = hasImage
    ? ''
    : `<span style="color:white;font-weight:700;font-size:14px;line-height:1">${(c.species || '?')[0].toUpperCase()}</span>`;
  return L.divIcon({
    className: '',
    html: `<div style="width:40px;height:40px;border-radius:50%;overflow:hidden;border:2.5px solid white;box-shadow:0 0 0 2.5px #36c9a2,0 2px 8px rgba(0,0,0,0.4);${bg};display:flex;align-items:center;justify-content:center;cursor:pointer">${inner}</div>`,
    iconSize: [40, 40],
    iconAnchor: [20, 20],
  });
}

const CatchesMapComponent = ({ catches, placeLat, placeLon }) => {
  const [lightboxIndex, setLightboxIndex] = useState(null);

  const mapped = useMemo(
    () => (catches || []).filter(c => c.lat != null && c.lon != null),
    [catches]
  );

  if (!placeLat || !placeLon) return null;

  const openLightbox = (idx) => setLightboxIndex(idx);

  return (
    <>
      <Box sx={{ borderRadius: 2, overflow: 'hidden', mb: 2, position: 'relative', border: '1px solid rgba(0,0,0,0.08)' }}>
        <MapContainer
          center={[placeLat, placeLon]}
          zoom={14}
          style={{ height: 240, width: '100%' }}
          scrollWheelZoom={false}
          attributionControl={false}
        >
          <TileLayer
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
          />
          {mapped.map((c, idx) => (
            <Marker
              key={c.id}
              position={[c.lat, c.lon]}
              icon={createCatchIcon(c)}
              eventHandlers={{ click: () => openLightbox(idx) }}
            />
          ))}
        </MapContainer>
        {mapped.length === 0 && (
          <Box
            sx={{
              position: 'absolute',
              bottom: 8,
              left: '50%',
              transform: 'translateX(-50%)',
              bgcolor: 'rgba(0,0,0,0.52)',
              borderRadius: 2,
              px: 1.5,
              py: 0.5,
              pointerEvents: 'none',
              zIndex: 500,
            }}
          >
            <Typography variant="caption" sx={{ color: 'white', fontSize: 11, whiteSpace: 'nowrap' }}>
              Połowy z GPS pojawią się na mapie
            </Typography>
          </Box>
        )}
      </Box>

      <CatchLightbox
        items={mapped}
        index={lightboxIndex}
        onClose={() => setLightboxIndex(null)}
        onIndexChange={setLightboxIndex}
      />
    </>
  );
};

export default CatchesMapComponent;
